export default {
    performer: 'Performer',
    title: 'Availability title',
    date: 'Date',
    offers: 'Services',
}
